import { moduleNavigation } from '@/config/navigation.generated';
import type { HelpPageSummary } from './helpApi';

/** Translates a menu label key, falling back to the untranslated label. */
export type MenuTranslate = (key: string, fallback: string) => string;

export interface HelpIndexModule {
  module: string;
  label: string;
  pages: HelpPageSummary[];
}

/** The help pages grouped by module, in menu order and named as the menu names them; titles alphabetical within a module. */
export function helpIndexModules(pages: HelpPageSummary[], translate: MenuTranslate): HelpIndexModule[] {
  const modules = [...new Set(pages.map((p) => p.module))].sort(byMenuOrder);
  return modules.map((module) => ({
    module,
    label: moduleLabel(module, translate),
    pages: pages.filter((p) => p.module === module).sort((a, b) => a.title.localeCompare(b.title)),
  }));
}

/** Modules in the order of the menu, a module the menu does not list last; ties by name. */
export function byMenuOrder(a: string, b: string): number {
  const moduleOrder = moduleNavigation.map((m) => m.module);
  const rank = (module: string) => (moduleOrder.includes(module) ? moduleOrder.indexOf(module) : moduleOrder.length);
  return rank(a) - rank(b) || a.localeCompare(b);
}

function moduleLabel(module: string, translate: MenuTranslate): string {
  const nav = moduleNavigation.find((m) => m.module === module);
  return nav ? translate(nav.labelKey || nav.label, nav.label) : module;
}
